import { render, staticRenderFns } from "./SectionServicesAU.vue?vue&type=template&id=07035dcc"
import script from "./SectionServicesAU.vue?vue&type=script&lang=js"
export * from "./SectionServicesAU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports